var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetailIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.025,
    height: 20.094,
    viewBox: "0 0 20.025 20.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10316",
    "data-name": "\\uD328\\uC2A4 10316",
    d: "M19.413,1.965,19.2,3.578a.566.566,0,0,1-.179.348c-.809.73-4.044,3.064-4.075,3.815,0,0-.136,1.1-.262,1.637a.5.5,0,0,1-.333.361l-1.2.4a.512.512,0,0,0-.308.282l-.677,1.566a.444.444,0,0,1-.328.446l-.568.2a1.275,1.275,0,0,0-.8,1.372,4.824,4.824,0,0,1,.053.724,4.586,4.586,0,0,1-1.4,3.364,4.587,4.587,0,0,1-3.363,1.4,4.587,4.587,0,0,1-3.364-1.4,4.744,4.744,0,0,1,0-6.728,4.587,4.587,0,0,1,3.364-1.4,4.148,4.148,0,0,1,.67.07,1.21,1.21,0,0,0,1-.287s7.789-7.133,9.437-8.563a.751.751,0,0,1,.666-.162L19,1.368A.54.54,0,0,1,19.413,1.965ZM3.984,14.48A1.429,1.429,0,0,0,5,16.921a1.422,1.422,0,0,0,1.429-1.429,1.2,1.2,0,0,0-.149-.6A1.319,1.319,0,0,0,5,14.063,1.378,1.378,0,0,0,3.984,14.48Z",
    transform: "translate(-0.2 -0.194)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailIcon2);
export default __webpack_public_path__ + "static/media/DetailIcon2.e0b546be49d72671a9b757158b863d5f.svg";
export { ForwardRef as ReactComponent };